import { Timestamp } from 'firebase/firestore/lite';
import { TagUser } from '../account/account.model';
import { Flair } from '../flair/flair.model';
import { LinkMeta } from '.';

export enum PostCommentStatus {
    PUBLISHED = 0,
    DELETED_BY_ADMIN = 1,
    DELETED_BY_PUBLISHER = 2,
    PENDING = 5
}

export enum PostStatus {
    PUBLISHED = 0,
    DELETED_BY_TOKEN_ADMIN = 1,
    DELETED_BY_PUBLISHER = 2,
    DELETED_BY_DOMAIN_ADMIN = 3,
    DELETED_BY_CATEGORY_ADMIN = 4, // deprecated
    PENDING = 5,
    PENDING_TRANSCRIPT = 6,
    PUBLISHED_UNLISTED = 7,
    PUBLISHED_SCHEDULED = 8,
    DRAFT = 9
}

export interface PostPollLastVoters {
    count: number;
    lastVoters: string[];
}
export interface Post {
    id: string;
    blockchainId: string;
    tokenName: string;
    slugUrl?: string;
    publisherId: string;
    scTopId?: string;
    scTopAmount: number;
    scTotalAmount: number;
    scCount: number;
    publisherName: string;
    publisherProfileName?: string;
    publisherSlugUrl?: string;
    parentPostId?: string;
    publisherProfit: number;
    upvoterId: string;
    upvoterName: string;
    upvoteAmount: number;
    upvoterLink: string;
    upvoterTitle: string;
    upvoteDayTimestamp?: string;
    upvoteWeekTimestamp?: string;
    upvoteYearAndMonth?: string;
    upvoteTime: Timestamp;
    externalArticleUrl?: string;
    externalArticleId?: string;
    domain: string;
    title: string;
    pollId?: string;
    postContent: string;
    content: string;
    image: string;
    createdAt: Timestamp;
    updatedAt?: Timestamp;
    status: number;
    numComments: number;
    totalTips?: number;
    tippingUsers?: Record<string, number>; // userId, count
    tippingUserNames?: Record<string, number>; // userName, count
    numUpvotes: number;
    reactionsCount: Record<string, number>; // reactionName, count
    reactionsUsers: Record<string, string[]>; // reactionName, userId[]
    reactionsUsernames: Record<string, string[]>; // reactionName, username[]
    totalReaction: number;
    lastReactorsNames: string[]; // username[]
    totalIncome?: number;
    totalViews?: number;
    totalImpressions?: number;
    isPinned?: boolean;
    pinnedTime?: Timestamp;
    flairs?: string[];
    reason?: string;
    reasonText?: string;
    pollOptions?: string[];
    pollTotalVoters?: number;
    pollValues?: PostPollLastVoters;
    postTypes?: string[];
    isSyndicated?: boolean;
    syndicateUpdateTime?: boolean;
    createdByWhitelistedUser?: boolean;
    moderationScore?: number;
    moderationContent?: string;
}


export interface PostComment {
    id: string;
    commentId: string;
    tokenName: string;
    tipAmount?: number;
    postId: string;
    numComments: number;
    replyToCommentId: string;
    publisherId: string;
    publisherName: string;
    postTitle: string;
    taggedUsers?: TagUser[];
    content: string;
    status: PostCommentStatus;
    createdAt: Timestamp;
    totalTips?: number;
    scCount?: number;
    linkMeta?: LinkMeta | null;
    scTotalAmount?: number;
    tippingUsers?: Record<string, number>; // userId, count
    tippingUserNames?: Record<string, number>; // userName, count
    reactionsCount: Record<string, number>; // reactionName, count
    reactionsUsers: Record<string, string[]>; // reactionName, userId[]
    reactionsUsernames: Record<string, string[]>; // reactionName, username[]
}
